import React, { useEffect, useRef } from "react";

import { Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import MHeaderLine from "./MHeaderLine";

export const HeaderCategoryList = [
  {
    id: 1,
    title: "회사소개",
    link: "/about",
  },
  {
    id: 2,
    title: `제품소개`,
    link: "/products",
  },
  {
    id: 3,
    title: `성능\u00A0테스트\u00A0및\u00A0인증`,
    link: "#test",
  },
  {
    id: 4,
    title: `서비스\u00A0목록`,
    link: "#service",
  },
  {
    id: 5,
    title: `협력사`,
    link: "#partners",
  },
];

const MHeader = () => {
  const navigate = useNavigate();

  const [opened, { toggle }] = useDisclosure(false);

  const phoneMenuListRef = useRef<HTMLDivElement>(null);
  const burgerIconRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    burgerIconRef.current?.addEventListener("click", () => {
      opened
        ? (phoneMenuListRef.current!.style.transform = "translate(0, -120%)")
        : (phoneMenuListRef.current!.style.transform = "translate(0, 0)");
    });
  }, [opened]);

  useEffect(() => {
    window.scrollY &&
      window.addEventListener("scroll", () => {
        if (window.scrollY > 100)
          headerRef.current!.style.backgroundColor = "rgb(255,255,255)";
        else headerRef.current!.style.backgroundColor = "rgba(255,255,255,0)";
      });
  }, []);

  const menuOnclick = async (link: string) => {
    await navigate("/");

    window.scrollY &&
      window.scrollTo({
        top:
          document.querySelector<HTMLDivElement>(link)!.offsetTop -
          document.querySelector<HTMLDivElement>("#header")!.offsetHeight +
          120,
        behavior: "smooth",
      });
  };

  const phoneMenuOnclick = async (link: string) => {
    await navigate("/");
    window.scrollY &&
      window.scrollTo({
        top:
          document.querySelector<HTMLDivElement>(link)!.offsetTop -
          document.querySelector<HTMLDivElement>("#header")!.offsetHeight,
        behavior: "smooth",
      });

    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };

  const phoneLinkOnClick = (link: string) => {
    navigate(link);
    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };

  return (
    <header className="fixed left-0 top-0 w-full h-fit bg-white z-40">
      <div
        ref={headerRef}
        id="header"
        className="relative w-full h-fit px-[calc((100%-var(--container))/5)] max-h-20 lg:max-h-32 py-2 xl:py-5 overflow-hidden z-40 transition-all duration-300"
      >
        <div className="relative w-full h-full mx-auto flex justify-between items-end gap-6 xl:gap-16 2xl:gap-20">
          <Burger
            ref={burgerIconRef}
            opened={opened}
            onClick={toggle}
            className="block lg:hidden"
            size="md"
            color="green"
          />
          <div className="relative w-auto h-auto">
            <img
              alt="카이노스 바이오케미칼 로고"
              onClick={() => (window.location.href = "/")}
              className="!relative w-full h-full max-w-md max-h-10 lg:max-h-12 xl:max-h-[54px] py-1 object-contain cursor-pointer"
              src="/images/logo.webp"
              width={285}
              height={67}
            />
          </div>
          <div className="block lg:hidden relative w-fit h-fit p-1 mx-1 rounded-full">
            <IconBrandWhatsapp
              onClick={() => {
                window.location.href = "tel:010-7557-1757";
              }}
              size={30}
              stroke={1}
              className="text-main"
            />
          </div>
          <ul className="hidden relative w-fit h-fit text-center lg:flex justify-around items-center justify-items-center gap-5 2xl:gap-14 cursor-pointer">
            {HeaderCategoryList.map((v, i) => (
              <li
                key={i + "pc"}
                onClick={() =>
                  v.link.includes("/") ? navigate(v.link) : menuOnclick(v.link)
                }
                className="text-center"
              >
                <p className="text-base 2xl:text-lg">{v.title}</p>
              </li>
            ))}
          </ul>
          <div className="hidden lg:block relative w-fit h-fit max-w-96">
            <img
              onClick={() => {
                window.location.href = "tel:010-7557-1757";
              }}
              className="!relative w-full h-full max-h-14 lg:max-h-16 object-contain cursor-pointer"
              alt="전화 상담 문의 010-7557-1757"
              src="/images/rightNum.webp"
              width={594}
              height={84}
            />
          </div>
        </div>
      </div>
      <MHeaderLine />
      <div
        ref={phoneMenuListRef}
        className="block lg:hidden fixed top-[50px] left-0 w-full h-full -translate-y-full transition-transform duration-500 z-30"
      >
        <ul className="border-b bg-white text-font">
          {HeaderCategoryList.map((v, i) => (
            <li
              key={i}
              onClick={() =>
                v.link.includes("/")
                  ? phoneLinkOnClick(v.link)
                  : phoneMenuOnclick(v.link)
              }
              className="border-b py-4 text-center"
            >
              <p className="text-base">{v.title}</p>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default MHeader;
